export const localPath = "";
export const iconPath = "/recursos/icons";

// routes: MenuWrapper
export const BILLING_ROUTE = "/facturacion";
export const ACCOUNT_ROUTE = "/mi-cuenta";
export const TEAM_ROUTE = "/empleados";
export const COMISSION_ROUTE = "/comisiones";
export const PRODUCTS_ROUTE = "/almacen";
export const LOUNGES_ROUTE = "/locales";
export const BOOKING_ROUTE = "/reservas";
export const PROMOTION_ROUTE = "/promociones";
export const TAXES_ROUTE = "/impuestos";
export const SERVICES_ROUTE = "/servicios";
export const CASH_REGISTER = "/cajas";
export const CLIENTS_ROUTE = "/clientes";
export const STATISTICS_ROUTE = "/estadisticas";
